import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-declare-victory',
		path: '/admin/p/:id/victory',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-petition-declareVictory" */ './index'), {
			exportName: 'DeclareVictory',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
	},
];
